import { BrowserRouter, Routes, Route} from 'react-router-dom'
import Home from "../pages/Home"
import Links from '../pages/Links'
import Now from '../pages/Now'
import Layout from '../pages/Layout'


export default function App() {

  return (
    <>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />}/>
            <Route path="links" element={<Links />} />
            <Route path="now" element={<Now />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}
